import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, of, tap} from "rxjs";

export interface ConnectionStatus {
  connected: boolean;
  connectionType: string;
}

@Injectable({
  providedIn: 'root'
})
export class NetworkService implements OnDestroy {
  networkStatus: ConnectionStatus | undefined;
  private status = new BehaviorSubject<ConnectionStatus | null>(null);
  private onlineHandler = () => this.sendStatusChangeMsg({connected: true, connectionType: 'wifi'});
  private offlineHandler = () => this.sendStatusChangeMsg({connected: false, connectionType: 'none'});

  constructor() {
    window.addEventListener('online', this.onlineHandler);
    window.addEventListener('offline', this.offlineHandler);
  }

  ngOnDestroy(): void {
    window.removeEventListener('online', this.onlineHandler);
    window.removeEventListener('offline', this.offlineHandler);
  }

  getStatusChangeObservable$(): Observable<ConnectionStatus | null> {
    return this.status.asObservable().pipe(
      tap((connectionStatus) => console.log('AAA connection status in network change', connectionStatus))
    );
  }

  sendStatusChangeMsg(status: ConnectionStatus): void {
    this.status.next(status);
  }

  async getNetWorkStatus(): Promise<boolean> {
    this.networkStatus = {connected: navigator.onLine, connectionType: navigator.onLine ? 'wifi' : 'none'};
    console.log(this.networkStatus);
    return !this.networkStatus?.connected;
  }

  // true = sono OFFLINE
  getNetworkStatus$(): Observable<boolean> {
    return of(!navigator.onLine);
  }
}
